import React, { useEffect, useMemo, useState } from "react";
import { Dimensions, Platform, ScrollView, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens } from "@voltmoney/schema";
import { SCREEN_SIZE } from '@voltmoney/types';
import { Typography } from "../../typography/Typography";
import { Icon } from "../../icon/Icon";
import { AppBottomNav } from "../../appBottomNav/AppBottomNav";
import { Button } from "../../button/Button";
const EmailStatementPage = ({ height, goBack, getEmailStatementAction, triggerAction, emailStatementButtonLoading = false }) => {
    const [_loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(emailStatementButtonLoading);
    }, [emailStatementButtonLoading]);
    const handleGoBack = () => {
        goBack &&
            triggerAction(goBack);
    };
    const handleGetEmailStatement = () => {
        getEmailStatementAction &&
            triggerAction(getEmailStatementAction);
    };
    const _headerChild = useMemo(() => {
        return (React.createElement(View, { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between'
            } },
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                } },
                React.createElement(View, { nativeID: "bt_transactions_goBack" },
                    React.createElement(TouchableOpacity, { style: {
                            position: 'relative',
                            top: 2,
                        }, onPress: () => handleGoBack() },
                        React.createElement(Icon, { name: IconTokens.ChevronLeft, size: IconSizeTokens.MD, color: ColorTokens.Grey_Night }))),
                React.createElement(View, { style: {
                        width: 8
                    } }),
                React.createElement(Typography, { label: 'Email statement', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '700', lineHeight: 24 }))));
    }, []);
    const _bodyChild = () => {
        return (React.createElement(ScrollView, { style: {
                height: '100%',
                paddingBottom: 16,
            } },
            React.createElement(View, null,
                React.createElement(Text, { style: {
                        fontFamily: 'Poppins',
                        fontSize: 16,
                        fontWeight: '700',
                        fontStyle: 'normal',
                        lineHeight: 24,
                        color: '#1D2939'
                    } }, "Get transactions Pdf")),
            React.createElement(View, { style: {
                    paddingTop: 8
                } },
                React.createElement(Text, { style: {
                        fontFamily: 'Inter',
                        fontSize: 14,
                        fontWeight: '400',
                        fontStyle: 'normal',
                        lineHeight: 20,
                        color: '#667085'
                    } }, "This pdf will be send to your email address")),
            React.createElement(View, { nativeID: 'bt_transactions_emailStatement', style: {
                    paddingTop: 24,
                    width: '100%'
                } },
                React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, label: 'Email statement', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, width: ButtonWidthTypeToken.FULL, loading: _loading, onPress: () => handleGetEmailStatement() }))));
    };
    const _footerChild = useMemo(() => {
        return (React.createElement(View, { style: {
                width: '100%',
            } },
            React.createElement(AppBottomNav, { currentRoute: 'TRANSACTIONS' })));
    }, []);
    return (React.createElement(View, { style: [
            styles.container,
            { height: Platform.OS === "ios" ? height - 35 : height }
        ] },
        React.createElement(View, { style: {
                flex: 1
            } },
            React.createElement(View, { style: styles.header }, _headerChild),
            React.createElement(View, { style: [styles.body, { height: height - 108 }] }, _bodyChild()))));
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
    header: {
        paddingHorizontal: 16,
        paddingTop: 12,
        paddingBottom: 12,
        borderBottomWidth: 1,
        borderBottomColor: '#F1F3F5',
        backgroundColor: '#FFF',
        shadowOffset: { width: 0, height: 1 },
        shadowColor: 'rgba(208, 213, 221, 0.25)',
        shadowOpacity: 1,
        shadowRadius: 6,
        elevation: 1,
        height: 50,
        ...Platform.OS === "ios" && {
            marginTop: 12,
            paddingBottom: 12
        }
    },
    body: {
        paddingHorizontal: 16,
        paddingTop: 24
    },
    footer: {
        position: 'absolute',
        bottom: '0',
        zIndex: 99,
        width: '100%',
        backgroundColor: '#FFF',
        borderWidth: 1,
        borderColor: '#F1F3F5',
        shadowColor: '#D0D5DD',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.25,
        shadowRadius: 6,
        elevation: 2,
    },
    groupContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    transactionCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
    },
    transactionLeftCardContainer: {
        flex: 3,
        display: 'flex',
        flexDirection: 'row',
    },
    transactionRightCardContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end'
    }
});
export default (EmailStatementPage);
